import { addUniqueItem, removeItem } from '../../utils/array.js';
import { compareByDepth } from './compare-by-depth.js';

var FlatTree = function () {
  function FlatTree() {
    this.children = [];
    this.isDirty = false;
  }

  FlatTree.prototype.add = function (child) {
    addUniqueItem(this.children, child);
    this.isDirty = true;
  };

  FlatTree.prototype.remove = function (child) {
    removeItem(this.children, child);
    this.isDirty = true;
  };

  FlatTree.prototype.forEach = function (callback) {
    this.isDirty && this.children.sort(compareByDepth);
    this.isDirty = false;
    this.children.forEach(callback);
  };

  return FlatTree;
}();

export { FlatTree };